export const formatCurrency = (value: number): string => {
    return value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};

export const formatBRLNumber = (value: number): string => {
    return value.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};

export const parseBRLNumber = (value: string): number => {
    if (!value) return 0;
    // Remove dots (thousands) and replace comma with dot (decimal)
    const cleanValue = value.replace(/\./g, '').replace(',', '.');
    return parseFloat(cleanValue) || 0;
};

type Dim = number | string | undefined;

const toNum = (v: Dim): number => {
    if (v === undefined || v === null || v === '') return 0;
    const n = parseFloat(String(v).replace(',', '.'));
    return isNaN(n) ? 0 : n;
};

export const getRoomMetrics = (room: { width?: Dim; depth?: Dim; height?: Dim }) => {
    const w = toNum(room.width);
    const d = toNum(room.depth);
    const h = toNum(room.height);
    const area = w * d;
    const perimeter = (w + d) * 2;
    const wallArea = perimeter * h;
    return { w, d, h, area, perimeter, wallArea };
};

export const formatArea = (m2: number): string =>
    `${m2.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} m²`;

export const formatLinear = (m: number): string =>
    `${m.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} m`;

export const formatDim = (v: Dim): string =>
    toNum(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
